/**
 * Store: Market Switcher
 * -----------------------------------------------------------------------------
 * Handles market switcher state.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    currentCountry: {},
    currentLanguage: {},
    display: 'countries',
    geolocation: {},
    preference: {},
    suggestedCountry: {},
  }),

  mutations: {

    /**
     * Set current object.
     * @param {Object} object - Current country/language.
     * @param {String} object.type - Type, either `country` or `language`.
     */
    SET_CURRENT(state, object) {
      if (!object) {
        return
      }

      const property = object.type === 'language'
        ? 'currentLanguage'
        : 'currentCountry'

      state[property] = object
    },

    /**
     * Set display.
     * @param {String} display - What to display in drawer.
     */
    SET_DISPLAY(state, display) {
      state.display = display
    },

    /**
     * Set geolocation.
     * - Persists in Vuex state.
     * @param {Object} geolocation - Geolocation from query.
     */
    SET_GEOLOCATION(state, geolocation) {
      state.geolocation = geolocation
    },

    /**
     * Set preference.
     * - Persists in Vuex state.
     * @param {String} country - User preference.
     */
    SET_PREFERENCE(state, country) {
      state.preference = country
    },

    /**
     * Set suggested country.
     * @param {Object} country - Suggested country based on geolocation or
     * user's saved preferences.
     */
    SET_SUGGESTED_COUNTRY(state, country) {
      state.suggestedCountry = country
    },
  },

  actions: {

    /**
     * Commit current object.
     * @param {Object} object - Current object.
     * @param {String} object.type - Type, either `country` or `language`.
     */
    setCurrent({ commit }, object) {
      commit('SET_CURRENT', object)
    },

    /**
     * Commit display.
     * @param {String} display - What to display in drawer.
     */
    setDisplay({ commit }, display = 'countries') {
      commit('SET_DISPLAY', display)
    },

    /**
     * Commit geolocation.
     * - Persists in Vuex state.
     * @param {Object} geolocation - Geolocation from query.
     */
    setGeolocation({ commit }, geolocation) {
      commit('SET_GEOLOCATION', geolocation)
    },

    /**
     * Set preference.
     * - Persists in Vuex state.
     * @param {String} country - User preference.
     */
    setPreference({ commit }, country) {
      commit('SET_PREFERENCE', country)
    },

    /**
     * Commit suggested country.
     * @param {Object} country - Suggested country based on geolocation or
     * user's saved preferences.
     */
    setSuggestedCountry({ commit }, country) {
      commit('SET_SUGGESTED_COUNTRY', country)
    },
  },
}
